var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58958 0.41107C1.26414 0.085633 0.736507 0.0856329 0.41107 0.41107C0.085633 0.736506 0.0856329 1.26414 0.41107 1.58958L4.82183 6.00034L0.411094 10.4111C0.0856571 10.7365 0.0856571 11.2641 0.411094 11.5896C0.736531 11.915 1.26417 11.915 1.58961 11.5896L6.00034 7.17885L10.4111 11.5896C10.7365 11.915 11.2642 11.915 11.5896 11.5896C11.915 11.2642 11.915 10.7365 11.5896 10.4111L7.17885 6.00034L11.5896 1.58958C11.915 1.26415 11.915 0.736508 11.5896 0.411071C11.2642 0.085634 10.7365 0.0856344 10.4111 0.411071L6.00034 4.82183L1.58958 0.41107Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e4965db63434244bbc7187b5aaeb684c.svg";
export { ForwardRef as ReactComponent };